import * as THREE from "three";
import { Platform, Scene } from "../_common/3d";
import { Warehouse, Airship } from "../_assets/3d";
import { StateStore } from "../utils";

let initialized = false;
let onInit = null;
let warehouse, airship;
let cleanupTimeout = null;

const transitionIn = () => {
  warehouse.animate().jumpIn(null, 7);
  airship.reset().float(0.02, 1).popIn();

  Platform().spin();
  Scene()
    .changeBackgroundColor({ color: new THREE.Color(0x96ffd8) })
    .showHideGrid(true);
};

const transitionOut = () => {
  warehouse.stop().sinkOut(null, 4);
  airship.popOut(null, 4);

  cleanupTimeout = setTimeout(() => {
    // Perform resource cleanup after scene has transitioned out
    Platform().removeChildren([warehouse, airship]);
    warehouse = null;
    airship = null;

    if (!/team|architect|ship/.test(StateStore.retrieve("page")))
      Platform().destroy();

    initialized = false;
    Scene().renderer.renderLists.dispose();
  }, 2000);
};

const create = () => {
  clearTimeout(cleanupTimeout);

  if (initialized) return onInit && onInit();

  warehouse = Warehouse({
    position: { y: 0, x: 0, z: 0 },
  });
  airship = Airship({
    delay: 600,
    position: { x: 0.86, y: 1.9, z: 1 },
    rotation: { y: -Math.PI / 2 },
    scale: 1.9,
  });

  warehouse.hide();
  airship.hide();

  Platform({
    children: [warehouse, airship],
  });

  initialized = true;

  onInit && setTimeout(onInit, 200);
};

const whenReady = (func) => {
  if (!func) return;

  if (!initialized) {
    onInit = func;
    return;
  }

  func();
};

export { create, transitionIn, transitionOut, whenReady };
